import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons'
import { useDispatch } from 'react-redux'
import { updateEntry } from 'apps/formsCreationKit/store/actions/sharedActions'
import {
  stateAbbreviations,
  stateNames,
  monthList,
  weekdayList,
  australiaStateAbbreviations,
  australiaStateNames,
  canadaProvinceAbbreviations,
  canadaProvinceNames,
  passFailChoices,
} from 'apps/studio/lib/choiceList'

import { ChevronRightIcon } from '@gocanvas/gcds/icons'

import { lib } from '@gocanvas/client'
const { SINGLE_CHOICE_BOXES_STYLE } = lib

const transformCommonListOptions = option => {
  const newList = option.values.map((entry, i) => {
    return {
      text: entry,
      position: i,
      placeholder: 'Type your choice here and press Enter',
    }
  })
  return { ...option, values: newList }
}
const commonListOptions = [
  {
    description: 'US State Abbreviations',
    values: stateAbbreviations,
    id: 1,
  },
  {
    description: 'US State Names',
    values: stateNames,
    id: 2,
  },
  {
    description: 'Month',
    values: monthList,
    id: 3,
  },
  {
    description: 'Weekday',
    values: weekdayList,
    id: 4,
  },
  {
    description: 'Australian State Abbreviations',
    values: australiaStateAbbreviations,
    id: 7,
  },
  {
    description: 'Australian State Names',
    values: australiaStateNames,
    id: 8,
  },
  {
    description: 'Canadian Province Abbreviations',
    values: canadaProvinceAbbreviations,
    id: 5,
  },
  {
    description: 'Canadian Province Names',
    values: canadaProvinceNames,
    id: 6,
  },
  {
    description: 'Pass/Fail',
    values: passFailChoices,
    id: 9,
  },
].map(transformCommonListOptions)

export const CommonListChoices = ({ guid, style, maximum }) => {
  const dispatch = useDispatch()
  return (
    <div className="common-list-choices-wrapper">
      {commonListOptions.map(({ values, description }) => {
        const updatedEntryValues =
          style === SINGLE_CHOICE_BOXES_STYLE
            ? values.slice(0, maximum)
            : values
        return (
          <div
            className="option--input"
            key={description}
            onClick={() =>
              dispatch(
                updateEntry({
                  guid,
                  entry_values: updatedEntryValues,
                })
              )
            }
          >
            {description}
            <ChevronRightIcon className="option--icon"/>
          </div>
        )
      })}
    </div>
  )
}
